<template>
  <div class="status-label">
    <div class="label" :class="progress['value']">
      {{progress['label']}} 
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-status-label',
  components: {

  },
  props: {
    label: {
      required: false
    },
    status:{
      required: false
    },
    progress:{
      type: Object,
      default: () => {
        return {
          label: 'LEAD',
          value: 'lead'
        }
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>